import React from 'react';
import { Col, DatePicker, Form, FormInstance, Input, Row, SupplierSelect } from 'components';
import { FilterDrawer } from 'components/common';
import { CalendarIcon } from 'components/common/icons';
import styles from 'pages/admin/clients/styles.module.scss';
import { useFilters } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid/filters/useFilters';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={applyFilters}
        initialValues={{
          dateRange: [null, null],
          supplierIds: null,
          countryId: null,
          industryId: null,
          tags: null,
          minPurchaseRequests: null,
          maxPurchaseRequests: null,
        }}
      >
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="supplierIds" label={'Supplier'}>
              <SupplierSelect mode={'multiple'} maxTagCount={'responsive'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row gutter={16} wrap={false} align={'bottom'}>
              <Col span={12}>
                <Form.Item name="minMarkup" label={'Margin'}>
                  <Input placeholder={'Min'} type={'number'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="maxMarkup">
                  <Input placeholder={'Max'} type={'number'} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16} wrap={false} align={'bottom'}>
              <Col span={12}>
                <Form.Item name="minAverageMargin" label={'Average Margin'}>
                  <Input placeholder={'Min'} type={'number'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="maxAverageMargin">
                  <Input placeholder={'Max'} type={'number'} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16} wrap={false} align={'bottom'}>
              <Col span={12}>
                <Form.Item name="minDealsCount" label={'Deals Count'}>
                  <Input placeholder={'Min'} type={'number'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="maxDealsCount">
                  <Input placeholder={'Max'} type={'number'} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16} wrap={false} align={'bottom'}>
              <Col span={12}>
                <Form.Item name="minDealsAmount" label={'Deals Amount'}>
                  <Input placeholder={'Min'} type={'number'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="maxDealsAmount">
                  <Input placeholder={'Max'} type={'number'} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={16} wrap={false} align={'bottom'}>
              <Col span={12}>
                <Form.Item name="minAverageLeadTime" label={'Lead Time'}>
                  <Input placeholder={'Min'} type={'number'} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="maxAverageLeadTime">
                  <Input placeholder={'Max'} type={'number'} />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Form.Item name="dateRange" label={'Price List Updated Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
